export const IMAGE_BLUR_DIMENSIONS = {
  width: 10,
};
